/* unplugin-vue-components disabled */import { render } from "./return-trip.vue?vue&type=template&id=57843ee9"
import script from "./return-trip.vue?vue&type=script&lang=js"
export * from "./return-trip.vue?vue&type=script&lang=js"

import "./return-trip.vue?vue&type=style&index=0&id=57843ee9&lang=less"

import exportComponent from "E:\\ProjectsWorkspaces\\WebStormProjects\\OCHS-Product-Disda-Online-Car-Hailing-H5\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_7401bc125e2957ce4091f6809056b31d\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__